"use strict"

/**
 * @name 统一接口请求封装
 * @link  文档查阅 https://fcdata.yuque.com/qqh85l/uggbsz/gg1re7h6b7ntcrgm
 */

import axios from "axios";
import {
  message,
  Modal,
  notification,
} from "ant-design-vue";

/**
 * header 配置
 */
const contentType = "application/json;charset=UTF-8";
// const contentType = "multipart/form-data";
let requestData = null;
//
const Request = {};

/**
 * error message list
 */
const errMsg = {
  400: "错误请求",
  401: "未授权，请重新登录",
  403: "拒绝访问",
  404: "请求错误,未找到该资源",
  405: "请求方法未允许",
  408: "请求超时",
  500: "服务器端出错",
  501: "网络未实现",
  502: "网络错误",
  503: "服务不可用",
  504: "网络超时",
  505: "http版本不支持该请求",
};

/**
 * @name 消息弹出
 * @param data
 * @returns
 */
const messageFun = (data) => {
  const { config } = data;
  if (config.message && config.message.noShow) return;

  // 系统消息
  if (config.message && config.message.options.content) {
    return message.open({
      ...config.message.options,
      duration: config.message.options.duration || 2,
    });
  }

  // 系统消息
  if (data.res.message) {
    message.open({
      content: data.res.message,
      duration: 2,
      type: 'info'
    });
  }
}


//
message.config({
  maxCount: 1
});

/**
 * @name 对参数进行formData处理
 * @param params
 * @returns
 */
const getFormData = () => {
  let formData = new FormData();
  if (requestData) {
    formData = Object.keys(requestData).reduce((arr, item, index) => {
      //二进制流文件 FormData处理
      if (isFile(requestData[item])) {
        // const formDataParams = new FormData();
        // formDataParams.append(item,params[item]);
        arr.append('file', requestData[item]);
        return arr;
      } else if (isFile(requestData[item].originFileObj)) {
        arr.append('file', requestData[item].originFileObj);
        return arr;
      }

      arr.append(item, requestData[item]);
      return arr;
    }, formData)
  }
  return formData;
};

/**
 * @name
 */
const isFile = (params) => {
  return Object.prototype.toString.call(params) === '[object File]';
};


/**
 * axios创建对象
 */
const axiosInstance = axios.create({
  baseURL: '', // 公共接口-本地
  timeout: 10 * 1000, // 超时时间单位是ms
  withCredentials: true, // 身份验证
  headers: {
    "Content-Type": contentType,
    'X-Requested-With': 'XMLHttpRequest', // 兼容老的登录请求
  },
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换

    // 执行form-data序列化
    if (config.headers['Content-Type'] === 'multipart/form-data') {
      config.data = getFormData();
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    const { data, config } = response;
    if (config.headers.responseType === 'blob') {
      return Promise.resolve(response);
    }
    if (data.code && +data.code !== 200) {
      switch (data.code) {
        case 302: //登录失效code
          notification.info({
            message: '登录失效',
            description: data.msg || data.message,
            duration: 2,
          });
          break;
        case "401": //无权限code
          notification.info({
            message: '无权限code',
            description: data.msg || data.message,
            duration: 2,
          });
          break;
        case 13:
          break;
        case 14:
          break;
        default:
          if (data.data === 302) {
            Modal.confirm({
              title: "登录过期",
              content: "登录状态已过期，是否重新登录？"
            });
          } else {
            notification.info({
              message: '操作失败',
              description: data.msg || data.message,
              duration: 2,
            });
          }
          break;
      }

      return Promise.reject(
        "okr请求异常拦截:" +
        JSON.stringify({
          url: config.url,
          code: data.code,
          data: data.data,
          msg: data.msg,
        }) || "Error"
      );
    } else {
      // 返回体改造，保持结构一致 -_-后端返回体不同意就该怼
      if (data.data.list) {
        return Promise.resolve({
          ...data,
          result: data.data.list,
          totalCount: +data.data.total || +data.data.totalCount
        });
      }
      // 返回体改造，保持结构一致-_-后端返回体不同意就该怼
      if (data.data.data) {
        return Promise.resolve({
          ...data,
          result: data.data.data,
          totalCount: +data.data.total || +data.data.totalCount
        });
      }

      // 裸返回啊 -_-
      if (!data.data) {
        return Promise.resolve(data);
      }

      return Promise.resolve({
        ...data,
        result: data.data
      });

    }
  },
  (error) => {
    if (error && error.response) {
      error.message =
        errMsg[error.response.status] || `连接错误${error.response.status}`;
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {

        //
        message.error(h => h('span', [
          h('span', '服务器响应超时，请刷新当前页，或重新登陆'),
          // h('a', {
          //   style: 'margin-left:4px',  // 样式内容
          //   on: {
          //     click: this.onLogout  // 点击事件
          //   }
          // }, '重新登陆'),
          h('span', {
            style: 'margin-left:4px'
          }, '试试!')
        ]));
      } else {
        message.error(`连接服务器失败:${error.message}`);
      }
    }
    // message.error(error.message);
    return Promise.reject(error);
  }
);


/**
 * @name get请求
 */
Request.get = (url, data, config) => {
  let result;
  //
  new Promise((resolve) => {
    result = axiosInstance.get(url, { params: data, ...config});
    return resolve(result);
  }).then((res) => {
    messageFun({
      config,
      res
    });
  });
  return result;
};

/**
 * @name post请求
 */
Request.post = (url, data, config) => {
  let result;

  new Promise((resolve) => {
    result = axiosInstance.post(url, data, config);
    //TODO 获取请求参数
    requestData = data;
    return resolve(result);
  }).then((res) => {
    messageFun({
      config,
      res
    });
  });

  return result;
};

/**
 * @name put请求
 */
Request.put = (url, data, config) => {
  let result;
  new Promise((resolve) => {
    result = axiosInstance.put(url, data, config);
    //TODO 获取请求参数
    requestData = data;
    return resolve(result);
  }).then((res) => {
    messageFun({
      config,
      res
    });
  });
  return result;
};

/**
 * @name patch请求
 */
Request.patch = (url, data, config) => {
  let result;
  new Promise((resolve) => {
    result = axiosInstance.post(url, data, config);
    //TODO 获取请求参数
    requestData = data;
    return resolve(result);
  }).then((res) => {
    messageFun({
      config,
      res
    });
  });
  return result;
};

/**
 * @name delete请求
 */
Request.delete = (url, config) => {
  let result;
  new Promise((resolve) => {
    result = axiosInstance.delete(url, config);
    return resolve(result);
  }).then((res) => {
    messageFun({
      config,
      res
    });
  });
  return result;
};



const Get = Request.get;
const Post = Request.get;
const Put = Request.put;
const Patch = Request.patch;
const Delete = Request.delete;

export {
  Get,
  Post,
  Put,
  Patch,
  Delete,
};

export default Request;
